import { useQuery } from "@tanstack/react-query";

import api from "@/app/_module/services/api";
import { getApiUrl } from "@/app/_module/services/config";
import { endpoint } from "@/app/_module/services/endpoints";
import { handleApiCall } from "@/app/_module/utils/apiResponseHandler";

export interface AgencyTreeNode {
  id: string;
  name: string;
  parentAgencyId: string | null;
  depth: number;
}

export const useAgencyTree = (rootAgencyId?: string) => {
  return useQuery<AgencyTreeNode[]>({
    queryKey: ["agency-tree", rootAgencyId],
    queryFn: async () => {
      const result = await handleApiCall<{ data: AgencyTreeNode[] }>(async () => {
        return await api.get({
          url: getApiUrl(endpoint.agency.getSubAgencyTree(rootAgencyId!)),
        });
      });
      return result?.data ?? result ?? [];
    },
    enabled: !!rootAgencyId,
    staleTime: 5 * 60 * 1000, // 5 minutes — hierarchy rarely changes
  });
};
